<template>
  <div id="targetDataComponent">
      <div id="targetTableDiv">
        <b-table hover :items="listData" :fields="fields"
          :responsive="false"
          small
          selectable selection-mode="multi"
          @row-selected="onRowSelected"
          id="targetData">
          <template v-slot:cell(id)="data">
            <p class="mb-2 targetDataP">
            <b-icon scale="1.2" icon="display" v-if='data.item.type=="display"'></b-icon>
            <b-icon scale="1.2" icon="arrow-left-right" v-if='data.item.type=="line"'></b-icon>
            <b-icon scale="1.2" icon="arrow-left" v-if='data.item.type=="route"'></b-icon>
            <b-icon scale="1.2" icon="flag-fill" v-if='data.item.type=="pysakki"'></b-icon>
            <b-icon scale="1.2" icon="display" v-if='data.item.type=="displayGroup"'></b-icon>
            <span style="padding-left:0.5em;padding-right:0.5em;">{{ data.item.id }}</span>
            :
            <span style="padding-left:0.5em;padding-right:0.5em;"><b>{{ data.item.label }}</b></span>
            </p>
          </template>
        </b-table>
      </div>
  </div>
</template>

<script>

export default {
  name: 'AnnouncementTargetList',
  props: {
    targetdata: Array
  },
  data: function() {
        return {
          fields: [ 
            {key:'id',label: this.$t('announcement_targets.attachments_title'), sortable: true }
          ],
          currentPage: 1,
          selected: [],
          listData: [],
          listLength: 0,
          pagingPerPage: 10,
          filter: null,
          filterOn: ['id','name'],
          creatingNew: false
        }
  },
  created: function() {
    this.listData = this.targetdata;
  },
  mounted: function() {
  },
  computed: {

    },
  watch: {
    targetdata: function() {
      if(!this.creatingNew) {
        this.listData = this.targetdata;
      }
    }
  },
  methods: {
    emptyList() {
      this.listData = [];
      this.listLength = 0;
      this.currentPage = 1;
    },
    onRowSelected(items) {
      this.selected = items
    },
    removeSelectedTargets() {
      this.listData = this.listData.filter( (item) => !this.selected.includes( item ));
    },
    addTargets(list) {
      list.forEach((item) => {
      if(!this.targetDataContains(item, this.listData))
        {
          this.listData.push(item)
        } 
      });
    },
    getTargetListData() {
      var dispTargets = [];
      var lineTargets = [];
      var routeTargets = [];
      var pysakkiTargets = [];
      var targetObject = {};
      this.listData.forEach((item) => {
          var i = {};
          i.id = item.id;
          i.label = item.label;

          if(item.type == "display")
            dispTargets.push(i);
          else if (item.type == "line")
            lineTargets.push(i);
          else if (item.type == "route")
            routeTargets.push(i);
          else if (item.type == "pysakki")
            pysakkiTargets.push(i);
          else if (item.type == "displayGroup") 
            dispTargets.push(i);
      });
      targetObject.displayTargets = dispTargets;
      targetObject.lineTargets = lineTargets;
      targetObject.routeTargets = routeTargets;
      targetObject.pysakkiTargets = pysakkiTargets;
      return targetObject;
    },
    targetDataContains(item, list) {
      for(var i = 0; i < list.length; i++) {
        if(list[i].id === item.id && list[i].type === item.type) {
          return true;
        }
      }
      return false;
    } 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#targetData {
  height: 9em;
}

#targetTableDiv {
  height: 20em;
  overflow: auto;
}

.targetDataP {
  margin-top: -10px;
  margin-bottom: -10px!important;
}
</style>
